module.exports = __webpack_public_path__ + "img/facebook_profile_image.c19bd121.png";